module.exports = __webpack_public_path__ + "components/home-header/static/header-2--medium-e2b261b7fb10dde1adf082f2102f42f4.jpg";